import { Component, input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormControlName } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-inputerrors',
  encapsulation: ViewEncapsulation.ShadowDom,
  styleUrl: './styles.scss',
  template: ` <div>
    <slot></slot>
    <div
      class="flex flex-col text-sm"
      *ngIf="control() && !control().valid && !control().untouched"
    >
      <span *ngIf="control().hasError('required')" class="text-benzRed-700"
        >Diese Angabe wird benötigt</span
      >
      <span *ngIf="control().hasError('minlength')" class="text-benzRed-700"
        >Diese Angabe muss mindestens
        {{ control().getError('minlength').requiredLength }} Zeichen lang sein
      </span>
      <span *ngIf="control().hasError('email')" class="text-benzRed-700"
        >Diese Angabe muss eine E-Mail-Adresse sein</span
      >
      <span *ngIf="control().hasError('pattern')" class="text-benzRed-700"
      >Die Angabe entspricht nicht dem notwendigen Format: dd.mm.yyyy
      </span>
      <span *ngIf="control().hasError('expectValueOneOf')" class="text-benzRed-700"
      >Die Angabe muss eines der folgenden sein: {{ control().getError('expectValueOneOf').expectedOneOf!.join(', ') }}
      </span>
      <span *ngIf="control().hasError('notEquivalent')" class="text-benzRed-700"
        >Diese Angabe muss gleich "{{
          control().getError('notEquivalent').value
        }}" sein</span
      >
    </div>
  </div>`,
  imports: [NgIf],
})
export class InputerrorsComponent {
  public readonly control = input.required<FormControl>();
}
